module.exports = __webpack_public_path__ + "assets/26666c727fddebba3971baeee4a831bf.svg";